import { render, staticRenderFns } from "./TemplateQuestionnaire.vue?vue&type=template&id=672ea036&"
import script from "./TemplateQuestionnaire.vue?vue&type=script&lang=ts&"
export * from "./TemplateQuestionnaire.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports